
/* VLM — visual options; the native Shopify variant select remains the only cart source of truth. */
(() => {
  'use strict';
  const one = (sel, root = document) => root.querySelector(sel);
  const colors = [
    [/(^|\W)(noir|black|charcoal|anthracite)(\W|$)/i,'#202426'],
    [/(^|\W)(gris|grey|gray|silver|argent)(\W|$)/i,'#93999c'],
    [/(^|\W)(blanc|white|ivoire)(\W|$)/i,'#f0ece2'],
    [/(^|\W)(beige|sable|sand)(\W|$)/i,'#cbb898'],
    [/(^|\W)(vert|green|olive|kaki)(\W|$)/i,'#606c55'],
    [/(^|\W)(rouge|red|bordeaux)(\W|$)/i,'#ad4439'],
    [/(^|\W)(bleu|blue|navy)(\W|$)/i,'#5b7487'],
    [/(^|\W)(marron|brown|brun|chocolat)(\W|$)/i,'#836e55'],
    [/(^|\W)(orange|terracotta)(\W|$)/i,'#c5744b']
  ];
  function swatch(text) {
    const parts = String(text).split(/\s*\/\s*/).slice(0,2);
    const matched = parts.map(p => (colors.find(([re]) => re.test(p)) || [null, '#aaa9a2'])[1]);
    return matched.length > 1 ? 'linear-gradient(90deg,' + matched[0] + ' 50%,' + matched[1] + ' 50%)' : matched[0];
  }
  function setStatus(select) {
    const status = one('[data-vlm-stock]');
    if (!status) return;
    const option = select?.selectedOptions?.[0];
    if (!option) return;
    const available = option.dataset.available === 'true';
    const dot = document.createElement('span');
    dot.className = 'vlm-pdp-stock__dot ' + (available ? 'is-unknown' : 'is-out');
    status.hidden = available;
        status.replaceChildren(...(available ? [] : [dot, document.createTextNode(' Indisponible')]));
    const shipping = one('.vlm-pdp-shipping');
    if (shipping) {
      const isArmaflex = /armaflex-home/i.test(location.pathname);
      const main = isArmaflex ? '🚚 Livraison rapide et offerte en France métropolitaine' : '🚚 Livraison rapide à domicile';
      const link = document.createElement('a');
      link.href = '/pages/livraison-vlm';
      link.textContent = 'Livraison & délais →';
      shipping.replaceChildren(document.createTextNode(main + ' 📍 Retrait possible au showroom VLM '), link);
    }
  }
  function buildChoiceUi(data, native) {
    if (!Array.isArray(data.variants) || !data.variants.length || !Array.isArray(data.options) || !data.options.length) return;
    const variants = data.variants.filter(v => v && v.id && Array.isArray(v.options));
    if (!variants.length) return;
    const optionNames = data.options.map((o, i) => (typeof o === 'string' ? o : (o && o.name)) || 'Option ' + (i + 1));
    const axes = optionNames.map((name, index) => ({
      name, index,
      values: [...new Set(variants.map(v => v.options[index]).filter(v => v != null).map(String))],
      isColor: /(couleur|coloris|colour|color|teinte)/i.test(name)
    }));
    if (axes.length > 3 || axes.some(axis => !axis.values.length)) return;
    if (axes.length === 1 && axes[0].values.length > 24) return;
    const chosen = variants.find(v => String(v.id) === String(native.value)) || variants.find(v => v.available) || variants[0];
    let selected = chosen.options.map(String);
    const nativeWrapper = native.closest('label');
    if (!nativeWrapper) return;
    const panel = document.createElement('div');
    panel.className = 'vlm-variant-ux';
    panel.setAttribute('data-vlm-visual-choices', '');
    panel.setAttribute('aria-label', 'Personnaliser votre produit');
    const controls = [];
    const summary = document.createElement('p');
    summary.className = 'vlm-variant-ux__result';
    summary.setAttribute('aria-live', 'polite');
    function pick(index, value) {
      if (!variants.some(v => v.available && String(v.options[index]) === value)) return;
      const strict = variants.find(v => v.available && v.options.every((x, i) => String(x) === (i === index ? value : selected[i])));
      const nearest = strict || variants
        .filter(v => v.available && String(v.options[index]) === value)
        .sort((a, b) => b.options.filter((x, i) => i !== index && String(x) === selected[i]).length -
                          a.options.filter((x, i) => i !== index && String(x) === selected[i]).length)[0];
      if (!nearest) return;
      selected = nearest.options.map(String);
      native.value = String(nearest.id);
      native.dispatchEvent(new Event('change', {bubbles:true}));
      refresh();
    }
    function refresh() {
      for (const c of controls) {
        const axis = axes[c.index];
        if (c.kind === 'select') {
          c.element.value = selected[c.index];
          for (const o of c.element.options) o.disabled = !variants.some(v => v.available && String(v.options[c.index]) === o.value);
        } else {
          c.element.querySelectorAll('button[data-choice-value]').forEach(btn => {
            const value = btn.dataset.choiceValue;
            const active = selected[c.index] === value;
            btn.classList.toggle('is-selected', active);
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
            btn.disabled = !variants.some(v => v.available && String(v.options[c.index]) === value);
          });
        }
        c.selectedLabel.textContent = selected[c.index] || '';
      }
      summary.textContent = 'Votre sélection : ' + axes.map(a => selected[a.index]).join(' · ');
    }
    axes.forEach(axis => {
      const field = document.createElement('fieldset');
      field.className = 'vlm-variant-ux__group';
      const legend = document.createElement('legend');
      legend.className = 'vlm-variant-ux__legend';
      legend.appendChild(document.createTextNode(axis.name + ' : '));
      const val = document.createElement('small');
      legend.appendChild(val);
      field.appendChild(legend);
      const isSelect = axis.values.length > (axis.isColor ? 18 : 12);
      if (isSelect) {
        const input = document.createElement('select');
        input.className = 'vlm-variant-ux__select';
        input.setAttribute('aria-label', axis.name);
        axis.values.forEach(value => {
          const option = document.createElement('option');
          option.value = value; option.textContent = value;
          input.appendChild(option);
        });
        input.addEventListener('change', () => pick(axis.index, input.value));
        field.appendChild(input);
        controls.push({index:axis.index, kind:'select', element:input, selectedLabel:val});
      } else {
        const grid = document.createElement('div');
        grid.className = 'vlm-variant-ux__grid' + (axis.isColor ? ' is-color' : '');
        axis.values.forEach(value => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'vlm-variant-ux__choice' + (axis.isColor ? ' is-color' : '');
          button.dataset.choiceValue = value;
          button.setAttribute('aria-label', axis.name + ' : ' + value);
          if (axis.isColor) {
            const color = document.createElement('span');
            color.className = 'vlm-variant-ux__swatch';
            color.style.background = swatch(value);
            color.setAttribute('aria-hidden', 'true');
            button.appendChild(color);
          }
          const name = document.createElement('span');
          name.className = 'vlm-variant-ux__label';
          name.textContent = value;
          button.appendChild(name);
          button.addEventListener('click', () => pick(axis.index, value));
          grid.appendChild(button);
        });
        field.appendChild(grid);
        controls.push({index:axis.index, kind:'buttons', element:grid, selectedLabel:val});
      }
      panel.appendChild(field);
    });
    panel.appendChild(summary);
    nativeWrapper.after(panel);
    nativeWrapper.classList.add('vlm-native-choice--enhanced');
    native.dataset.vlmVisualReady = 'true';
    native.addEventListener('change', () => {
      const v = variants.find(v => String(v.id) === String(native.value));
      if (v) selected = v.options.map(String);
      refresh();
      setStatus(native);
    });
    refresh();
    setStatus(native);
  }
  async function init() {
    const native = one('.vlm-product-form select[data-vlm-variant-select]');
    if (!native) return;
    setStatus(native);
    try {
      const path = location.pathname.replace(/\/$/, '');
      const resp = await fetch(path + '.js', {headers:{Accept:'application/json'}});
      if (!resp.ok) return;
      const product = await resp.json();
      buildChoiceUi(product, native);
    } catch (e) {
      // Never hide Shopify's functional native selector on network or data failure.
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
